module.exports = __webpack_public_path__ + "static/media/collaborall.a2c80496.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/collaborall.webp
// module id = 679
// module chunks = 0